<template>
  <div>
    <van-icon class="add-btn" name="add" color="#1989fa" size="40px" @click="handleAdd" />
  </div>
</template>

<script>
import {Icon} from 'vant'
export default {
  name: "AddBtn",
  components:{
       [Icon.name]: Icon,
  },
  methods: {
    handleAdd() {
      this.$emit("add");
    },
  },
};
</script>
<style lang="less">
.add-btn {
  width: 150px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 200px;
  right: 40px;
  overflow: hidden;
  z-index: 1000;
}
</style>